import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type ReportFormState = {
  isLoading: boolean;
  isSuccess: boolean;
  isStatusModalOpen: boolean;
  isFormOpen: boolean;
  reason: string;
  details: string;
  isReported: boolean;
  isValidDetails: boolean;
  propertyId: number;
};

export const initialState: ReportFormState = {
  isLoading: false,
  isSuccess: false,
  isStatusModalOpen: false,
  isFormOpen: false,
  reason: '',
  details: '',
  isReported: false,
  isValidDetails: true,
  propertyId: 0
};

const reportFormSlice = createSlice({
  name: 'reportForm',
  initialState,
  reducers: {
    setIsFormOpen: (state, action: PayloadAction<boolean>) => {
      return { ...state, isFormOpen: action.payload };
    },
    setReason: (state, action: PayloadAction<string>) => {
      const isValid =
        (action.payload === 'Otro motivo' && state.details.length > 0) ||
        action.payload !== 'Otro motivo';
      state.reason = action.payload;
      state.isValidDetails = isValid;
    },
    setDetails: (state, action: PayloadAction<string>) => {
      const isValid =
        (state.reason === 'Otro motivo' && action.payload.length > 0) ||
        state.reason !== 'Otro motivo';
      return {
        ...state,
        details: action.payload,
        isValidDetails: isValid
      };
    },
    submitForm: (state) => {
      return {
        ...state,
        isLoading: true,
        isSuccess: false,
        isStatusModalOpen: false,
        isFormOpen: true
      };
    },
    submitFormSuccess: (state) => {
      return {
        ...state,
        isLoading: false,
        isSuccess: true,
        isStatusModalOpen: true,
        isFormOpen: false,
        isReported: true
      };
    },
    submitFormError: (state) => {
      return {
        ...state,
        isLoading: false,
        isSuccess: false,
        isStatusModalOpen: true,
        isFormOpen: false,
        isReported: false
      };
    },
    closeStatusModal: (state) => {
      return {
        ...initialState,
        isReported: state.isReported
      };
    },
    setPropertyId: (state, action: PayloadAction<number>) => {
      return {
        ...initialState,
        propertyId: action.payload
      };
    }
  }
});

export const {
  setIsFormOpen,
  setReason,
  setDetails,
  submitForm,
  submitFormSuccess,
  submitFormError,
  closeStatusModal,
  setPropertyId
} = reportFormSlice.actions;
export default reportFormSlice.reducer;
